import {SubscribeAuthorizationRequest} from './SubscribeAuthorizationRequest';
import {SubscribeAuthorizationResponse} from './SubscribeAuthorizationResponse';
import {BaseService, Metadata} from '@utex/base-api-sdk';


export class AuthorizationService extends BaseService {
    protected clientName: string = 'AuthorizationService'
    
    subscribeAuthorization = this.createStream<SubscribeAuthorizationResponse,SubscribeAuthorizationRequest,Metadata>('com.unitedtraders.luna.mobilegateway.authorization.AuthorizationService.subscribeAuthorization',true,'schema.json#/properties/subscribeAuthorizationRequest','schema.json#/properties/subscribeAuthorizationResponse','AuthorizationService/subscribeAuthorization');

}